import React from 'react';
import Helmet from 'react-helmet';
import { ColourTheme } from '../../types/ColourTheme';
import './Layout.scss';

type Props = {
  metaTitle: string;
  metaDesc: string;
  theme: ColourTheme;
};

export const Layout: React.FunctionComponent<Props> = props => {
  return (
    <div>
      <Helmet>
        <title>{props.metaTitle}</title>
        <meta name="description" content={props.metaDesc} />
      </Helmet>
      <div className="bodyContentWrapper">
        {props.children}
      </div>
    </div>
  );
};